
import React, { PureComponent } from 'react';
import Constants from '../Constants.js';
import Styles from './BoardStyles.js'


class Letter extends PureComponent {
  render() {

    let scale = (this.props.active ? 0.8 : 1.0);
    let pulseScale = (this.props.pulsing ? 0.6 : scale);
    pulseScale = (this.props.active ? 1.0 : pulseScale);
    scale = (this.props.hidden ? 0.0 : scale);

    return (
      <div style={{
        ...Styles.Tile,
        left: (this.props.col * Constants.tileSize) + 'px',
        top: (this.props.row * Constants.tileSize) + 'px',
        transform: 'scale(' + scale + ')',
        overflow: 'visible',
        textTransform: 'uppercase',
        willChange: 'transform',
        transition: 'top 400ms, transform 200ms',
      }}
      >
        <div style={{
            position: 'absolute',
            width: Constants.letterSize + 'px',
            height: Constants.letterSize + 'px',
            backgroundColor: this.props.colors.secondary,
            left: Constants.letterPadding + 'px',
            top: Constants.letterPadding + 'px',
            borderRadius: Constants.letterBorderRadius + 'px',
            boxShadow: '0 0 ' + (this.props.active || this.props.pulsing ? 0 : Constants.letterBlurRadius) + 'px ' + Constants.letterShadowColor,
            transform: 'scale(' + pulseScale + ')',
            overflow: 'visible',
            transition: 'transform 500ms',
          }}
        >
          <div style={{
              position: 'absolute',
              width: '100%',
              height: '100%',
              backgroundColor: (this.props.active || this.props.pulsing ? this.props.colors.secondary : this.props.colors.primary),
              top: (this.props.active ? 0 : -Constants.letterDepth) + 'px',
              borderRadius: Constants.letterBorderRadius + 'px',
              transition: 'background-color 200ms, top 200ms',
            }}
          >
            <div style={{
                color: '#fff',
                position: 'absolute',
                left: '50%',
                top: '50%',
                transform: 'translate(-50%,-50%)',
                fontSize: Constants.letterFontSize + 'px'
              }}
            >
              {this.props.letter}
            </div>
          </div>
        </div>
      </div>
    );
  }
}


export default Letter;
